// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: string;
};

export type CurrentUser = {
    id: string;
    email: string;
    login: string;
    firstName: string;
    lastName: string;
    locale: string | null;
    clientId: string | null;
    role: 'hello-admin' | 'hello-amesura' | 'hello-client';
};

export type MeResponse = {
    data: CurrentUser;
};

export type ApiTokenItem = {
    id: string;
    name: string;
    scope: 'read' | 'write';
    createdAt: string;
    lastUsedAt: string | null;
    expiresAt: string;
    revokedAt: string | null;
};

export type ApiTokenListResponse = {
    data: Array<ApiTokenItem>;
};

export type CreateApiTokenBody = {
    name: string;
    scope?: 'read' | 'write';
    expiresInDays: number;
};

export type CreatedApiTokenResponse = {
    data: {
        id: string;
        name: string;
        scope: 'read' | 'write';
        token: string;
    };
};

export type SuccessResponse = {
    data: {
        success: boolean;
    };
};

export type AdminApiTokenItem = {
    id: string;
    name: string;
    scope: 'read' | 'write';
    createdAt: string;
    lastUsedAt: string | null;
    expiresAt: string;
    revokedAt: string | null;
    role: 'hello-admin' | 'hello-amesura' | 'hello-client';
    userId: string;
    userEmail: string;
    userFirstName: string;
    userLastName: string;
};

export type AdminApiTokenListResponse = {
    data: Array<AdminApiTokenItem>;
};

export type InternalUser = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    createdAt: string;
    role: 'hello-admin' | 'hello-amesura' | 'hello-client' | null;
    enabled: boolean | null;
};

export type InternalUserListResponse = {
    data: Array<InternalUser>;
    keycloakAvailable: boolean;
};

export type CreateInternalUserBody = {
    email: string;
    firstName: string;
    lastName: string;
    role: 'hello-admin' | 'hello-amesura';
};

export type InternalUserProfile = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    createdAt: string;
};

export type CreatedInternalUserResponse = {
    data: {
        user: InternalUserProfile;
        temporaryPassword: string | null;
        adopted: boolean;
    };
};

export type UpdateInternalUserBody = {
    email?: string;
    firstName?: string;
    lastName?: string;
};

export type InternalUserProfileResponse = {
    data: InternalUserProfile;
};

export type SetInternalUserRoleBody = {
    role: 'hello-admin' | 'hello-amesura';
};

export type InternalUserRoleResponse = {
    data: {
        role: 'hello-admin' | 'hello-amesura';
    };
};

export type SetInternalUserEnabledBody = {
    enabled: boolean;
};

export type InternalUserEnabledResponse = {
    data: {
        enabled: boolean;
    };
};

export type ResetPasswordResponse = {
    data: {
        temporaryPassword: string;
    };
};

export type InternalDirectoryEntry = {
    id: string;
    firstName: string;
    lastName: string;
};

export type InternalDirectoryResponse = {
    data: Array<InternalDirectoryEntry>;
};

export type AdminClient = {
    id: string;
    name: string;
    logo: string | null;
    issuePrefix: string | null;
    portalEnabledAt: string | null;
    nextIssueNumber: number;
    createdAt: string;
    updatedAt: string;
    deactivatedAt: string | null;
    isActive: boolean;
};

export type AdminClientListResponse = {
    data: Array<AdminClient>;
};

export type CreateClientBody = {
    name: string;
    issuePrefix: string;
    logo?: string | null;
    enablePortal?: boolean;
};

export type AdminClientResponse = {
    data: AdminClient;
};

export type UpdateClientBody = {
    name?: string;
    logo?: string | null;
    issuePrefix?: string;
};

export type ClientStatusChangeResponse = {
    data: AdminClient;
    keycloakErrors?: Array<string>;
};

export type ClientUser = {
    id: string;
    email: string;
    login: string;
    firstName: string;
    lastName: string;
    locale: string | null;
    clientId: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
};

export type ClientUserListResponse = {
    data: Array<ClientUser>;
};

export type CreateClientUserBody = {
    email: string;
    firstName: string;
    lastName: string;
};

export type CreatedClientUserResponse = {
    data: {
        user: ClientUser;
        temporaryPassword: string;
    };
};

export type UpdateClientUserBody = {
    email?: string;
    firstName?: string;
    lastName?: string;
};

export type ClientUserResponse = {
    data: ClientUser;
};

export type DeleteClientUserResponse = {
    data: {
        success: true;
    };
    keycloakError?: string;
};

export type MyClient = {
    id: string;
    name: string;
    logo: string | null;
    isActive: boolean;
};

export type MyClientResponse = {
    data: MyClient;
};

export type LinkWithCategory = {
    id: string;
    name: string;
    url: string;
    label: string | null;
    icon: string | null;
    sortOrder: number;
    categoryId: string;
    createdAt: string;
    updatedAt: string;
    categoryName: string;
    categorySortOrder: number;
    categoryClientId: string | null;
};

export type LinkListResponse = {
    data: Array<LinkWithCategory>;
};

export type CreateLinkBody = {
    name: string;
    url: string;
    label?: string | null;
    icon?: string | null;
    sortOrder?: number;
    categoryId: string;
};

export type Link = {
    id: string;
    name: string;
    url: string;
    label: string | null;
    icon: string | null;
    sortOrder: number;
    categoryId: string;
    createdAt: string;
    updatedAt: string;
};

export type LinkResponse = {
    data: Link;
};

export type UpdateLinkBody = {
    name?: string;
    url?: string;
    label?: string | null;
    icon?: string | null;
    sortOrder?: number;
    categoryId?: string;
};

export type ReorderLinksBody = {
    items: Array<{
        id: string;
        sortOrder: number;
    }>;
};

export type ReorderedLinksResponse = {
    data: Array<Link>;
};

export type LinkCategory = {
    id: string;
    name: string;
    clientId: string | null;
    sortOrder: number;
    createdAt: string;
    updatedAt: string;
};

export type LinkCategoryListResponse = {
    data: Array<LinkCategory>;
};

export type CreateLinkCategoryBody = {
    name: string;
    clientId?: string | null;
    sortOrder?: number;
};

export type LinkCategoryResponse = {
    data: LinkCategory;
};

export type UpdateLinkCategoryBody = {
    name?: string;
    clientId?: string | null;
    sortOrder?: number;
};

export type ReorderLinkCategoriesBody = {
    items: Array<{
        id: string;
        sortOrder: number;
    }>;
};

export type ProjectOverview = {
    id: string;
    name: string;
    icon: string | null;
    color: string | null;
    client: {
        id: string;
        name: string;
    } | null;
    applicationId: string | null;
    applicationName: string | null;
    allocationMode: 'total' | 'monthly' | 'none';
    allocatedMinutes: number | null;
    consumedTotalMinutes: number;
    consumedMonthMinutes: number;
    closedAt: string | null;
    restrictedToAdmin: boolean;
    applicationRestrictedToAdmin: boolean;
};

export type ProjectOverviewListResponse = {
    data: Array<ProjectOverview>;
};

export type CreateProjectBody = {
    clientId: string;
    name: string;
    applicationId?: string | null;
    restrictedToAdmin?: boolean;
};

export type CreatedProjectResponse = {
    data: {
        id: string;
        name: string;
    };
};

export type ProjectBudgetBody = {
    allocationMode: 'total' | 'monthly' | 'none';
    allocatedHours?: number | null;
};

export type ProjectBudgetResponse = {
    data: {
        allocationMode: 'total' | 'monthly' | 'none';
        allocatedMinutes: number | null;
    };
};

export type UpdateProjectDetailsBody = {
    name?: string;
    applicationId?: string | null;
    restrictedToAdmin?: boolean;
};

export type ProjectDetailsResponse = {
    data: {
        id: string;
        name: string;
        applicationId: string | null;
    };
};

export type ProjectClosureBody = {
    closed: boolean;
};

export type ProjectClosureResponse = {
    data: {
        closedAt: string | null;
    };
};

export type Milestone = {
    id: string;
    name: string;
    targetDate: string | null;
    sortOrder: number;
};

export type MilestoneListResponse = {
    data: Array<Milestone>;
};

export type CreateMilestoneBody = {
    name: string;
    targetDate?: string | null;
    sortOrder?: number;
};

export type MilestoneResponse = {
    data: Milestone;
};

export type Application = {
    id: string;
    clientId: string;
    name: string;
    description: string | null;
    icon: string | null;
    color: string | null;
    restrictedToAdmin: boolean;
};

export type ApplicationListResponse = {
    data: Array<Application>;
};

export type CreateApplicationBody = {
    clientId: string;
    name: string;
    description?: string | null;
    icon?: string | null;
    color?: string | null;
    restrictedToAdmin?: boolean;
};

export type CreatedApplicationResponse = {
    data: {
        id: string;
        clientId: string;
        name: string;
    };
};

export type UpdateApplicationBody = {
    name?: string;
    description?: string | null;
    icon?: string | null;
    color?: string | null;
    restrictedToAdmin?: boolean;
};

export type UpdateMilestoneBody = {
    name?: string;
    targetDate?: string | null;
    sortOrder?: number;
};

export type ClientProject = {
    id: string;
    name: string;
    color: string;
    icon: string | null;
    applicationId: string | null;
    applicationName: string | null;
    isOpenForIssues: boolean;
};

export type ClientProjectListResponse = {
    data: Array<ClientProject>;
};

export type UploadResponse = {
    data: {
        url: string;
    };
};

export type ImportUrlBody = {
    url: string;
    clientId?: string;
};

export type IssueLookupItem = {
    id: string;
    identifier: string;
    title: string;
    state?: {
        name: string;
        type: string;
    };
    parent?: {
        identifier: string;
    };
};

export type IssueLookupListResponse = {
    data: Array<IssueLookupItem>;
};

export type IssueResolveResponse = {
    data: {
        id: string;
        clientId: string;
    };
};

export type WorkflowState = {
    id: string;
    name: string;
    type: string;
    color: string;
    position: number;
};

export type IssueListItem = {
    id: string;
    identifier: string;
    title: string;
    description: string | null;
    state: IssueStateRef;
    assignee?: {
        name: string;
        id?: string;
    };
    priority: number;
    project?: IssueProjectRef;
    labels: Array<Label>;
    parent?: {
        id: string;
        identifier: string;
    };
    subIssues?: SubIssueCounts;
    visibleToClient: boolean;
    needsQualification: boolean;
    validation: 'OK' | 'KO' | null;
    createdAt: string;
    updatedAt: string;
    completedAt: string | null;
};

export type IssueStateRef = {
    id: string;
    name: string;
    type: string;
};

export type IssueProjectRef = {
    id: string;
    name: string;
};

export type Label = {
    name: string;
    color: string;
};

export type SubIssueCounts = {
    total: number;
    done: number;
};

export type IssueListResponse = {
    data: {
        workflowStates: Array<WorkflowState>;
        issues: Array<IssueListItem>;
    };
};

export type CreateIssueBody = {
    clientId?: string;
    title: string;
    description?: string;
    priority?: number;
    projectId?: string;
    labels?: Array<string>;
    parentIssueId?: string;
};

export type IssueRefResponse = {
    data: {
        id: string;
        identifier: string;
    };
};

export type IssueDetail = {
    id: string;
    identifier: string;
    title: string;
    description: string | null;
    state: IssueStateRef;
    assignee?: {
        name: string;
        id?: string;
    };
    priority: number;
    project?: IssueProjectRef;
    labels: Array<Label>;
    parent?: {
        id: string;
        identifier: string;
        title: string;
    };
    subIssues?: SubIssueCounts;
    visibleToClient: boolean;
    needsQualification: boolean;
    validation: 'OK' | 'KO' | null;
    createdAt: string;
    updatedAt: string;
    completedAt: string | null;
    clientId: string;
    children: Array<IssueDetailChild>;
    comments: Array<IssueDetailComment>;
    attachments: Array<IssueDetailAttachment>;
    history: Array<IssueHistoryEvent>;
};

export type IssueDetailChild = {
    id: string;
    identifier: string;
    title: string;
    state: IssueStateRef;
    assignee?: IssuePerson;
    subIssues?: SubIssueCounts;
};

export type IssuePerson = {
    name: string;
};

export type IssueDetailComment = {
    id: string;
    body: string;
    createdAt: string;
    updatedAt: string;
    user?: IssuePerson;
    isOwn: boolean;
};

export type IssueDetailAttachment = {
    id: string;
    title: string;
    url: string;
    filename: string;
    isOwn: boolean;
};

export type IssueHistoryEvent = {
    id: string;
    createdAt: string;
    actor?: IssuePerson;
    kind: 'created' | 'state' | 'assignee' | 'priority' | 'project' | 'title' | 'labels' | 'validation' | 'visibility' | 'parent' | 'other';
    fromState?: {
        name: string;
        type: string;
    };
    toState?: {
        name: string;
        type: string;
    };
    fromAssignee?: IssuePerson;
    toAssignee?: IssuePerson;
    fromPriority?: number;
    toPriority?: number;
    fromProject?: {
        name: string;
    };
    toProject?: {
        name: string;
    };
    fromTitle?: string;
    toTitle?: string;
    fromParent?: {
        identifier: string;
    };
    toParent?: {
        identifier: string;
    };
    addedLabels?: Array<Label>;
    removedLabels?: Array<Label>;
};

export type IssueDetailResponse = {
    data: IssueDetail;
};

export type UpdateIssueBody = {
    title?: string;
    description?: string;
    priority?: number;
    projectId?: string;
    labels?: Array<string>;
};

export type DeletedIssueResponse = {
    data: {
        id: string;
    };
};

export type IssueStateBody = {
    state: 'Backlog' | 'Todo' | 'In Progress' | 'In Review' | 'Development' | 'Tested' | 'Production' | 'Canceled';
};

export type IssueStateResponse = {
    data: {
        id: string;
        state: 'Backlog' | 'Todo' | 'In Progress' | 'In Review' | 'Development' | 'Tested' | 'Production' | 'Canceled';
    };
};

export type IssueAssignmentBody = {
    assigneeUserId: string | null;
};

export type IssueAssignmentResponse = {
    data: {
        id: string;
        assigneeUserId: string | null;
    };
};

export type IssueFlagsBody = {
    visibleToClient?: boolean;
    needsQualification?: boolean;
};

export type IssueFlagsResponse = {
    data: {
        id: string;
        visibleToClient: boolean;
        needsQualification: boolean;
    };
};

export type IssueParentBody = {
    parentIssueId: string | null;
};

export type IssueParentResponse = {
    data: {
        id: string;
        parentIssueId: string | null;
    };
};

export type IssueValidationBody = {
    validation: 'OK' | 'KO' | null;
};

export type IssueValidationResponse = {
    data: {
        id: string;
        labels: Array<Label>;
    };
};

export type IssueMergeRequest = {
    id: string;
    mrIid: number;
    title: string;
    state: string;
    url: string;
    sourceBranch: string;
    updatedAt: string;
};

export type IssueMergeRequestListResponse = {
    data: Array<IssueMergeRequest>;
};

export type IssueCommentBody = {
    body: string;
};

export type IssueCommentRefResponse = {
    data: {
        id: string;
    };
};

export type CreateAttachmentBody = {
    issueId: string;
    url: string;
    title: string;
};

export type Attachment = {
    id: string;
    title: string;
    url: string;
};

export type AttachmentResponse = {
    data: Attachment;
};

export type LabelListResponse = {
    data: Array<Label>;
};

export type GitlabWebhookBody = {
    object_kind?: string;
};

export type GitlabWebhookResponse = {
    data: {
        ignored?: true;
        identifier?: string;
        linked?: string;
        transitionedTo?: 'Backlog' | 'Todo' | 'In Progress' | 'In Review' | 'Development' | 'Tested' | 'Production' | 'Canceled';
    };
};

export type EnrichedMergeRequest = {
    id: number;
    iid: number;
    title: string;
    description: string;
    state: string;
    createdAt: string;
    updatedAt: string;
    sourceBranch: string;
    targetBranch: string;
    author: GitlabAuthor;
    webUrl: string;
    sourceProjectId: number;
    targetProjectId: number;
    draft: boolean;
    workInProgress: boolean;
    mergeStatus: string;
    hasConflicts: boolean;
    approvalCount: number;
    approverNames: Array<string>;
    commentCount: number;
    openThreads: number;
    resolvedThreads: number;
    currentUserHasApproved: boolean;
    currentUserOpenThreads: number;
    currentUserResolvedThreads: number;
};

export type GitlabAuthor = {
    id: number;
    username: string;
    name: string;
    avatarUrl: string;
    webUrl: string;
};

export type GitlabCurrentUser = {
    id: string;
    username: string;
    name: string;
    avatarUrl: string | null;
    webUrl: string;
};

export type GitlabDashboardResponse = {
    data: {
        mergeRequests: Array<EnrichedMergeRequest>;
        currentUser: GitlabCurrentUser;
    };
};

export type GitlabTokenStatusResponse = {
    data: {
        hasToken: boolean;
        tokenSetAt: string | null;
    };
};

export type SetGitlabTokenBody = {
    token: string;
};

export type GitlabTokenSavedResponse = {
    data: {
        saved: true;
    };
};

export type GitlabTokenDeletedResponse = {
    data: {
        deleted: true;
    };
};

export type TimesheetEntry = {
    id: string;
    entryDate: string;
    clientId: string;
    clientName: string;
    applicationId: string | null;
    applicationName: string | null;
    projectId: string | null;
    projectName: string | null;
    durationMinutes: number;
    durationHours: number;
    title: string | null;
    note: string | null;
    issueIdentifier: string | null;
    issueId: string | null;
    isMaintenance: boolean;
    createdAt: string;
    updatedAt: string;
};

export type TimesheetEntryListResponse = {
    data: Array<TimesheetEntry>;
};

export type CreateTimesheetEntryBody = {
    entryDate: string;
    clientId: string;
    applicationId?: string | null;
    projectId?: string | null;
    durationHours: number;
    title?: string | null;
    note?: string | null;
    issueIdentifier?: string | null;
    issueId?: string | null;
    isMaintenance?: boolean;
};

export type TimesheetEntryResponse = {
    data: TimesheetEntry;
};

export type UpdateTimesheetEntryBody = {
    entryDate?: string;
    clientId?: string;
    applicationId?: string | null;
    projectId?: string | null;
    durationHours?: number;
    title?: string | null;
    note?: string | null;
    issueIdentifier?: string | null;
    issueId?: string | null;
    isMaintenance?: boolean;
};

export type TimesheetSettingsResponse = {
    data: {
        workedDays: Array<number>;
    };
};

export type TimesheetSettingsBody = {
    workedDays: Array<number>;
};

export type TimesheetCatalogClient = {
    id: string;
    name: string;
};

export type TimesheetCatalogClientListResponse = {
    data: Array<TimesheetCatalogClient>;
};

export type TimesheetCatalogApplication = {
    id: string;
    name: string;
    description: string | null;
    icon: string | null;
    color: string | null;
};

export type TimesheetCatalogApplicationListResponse = {
    data: Array<TimesheetCatalogApplication>;
};

export type TimesheetCatalogProject = {
    id: string;
    name: string;
    icon: string | null;
    color: string | null;
    clientId: string | null;
    applicationId: string | null;
};

export type TimesheetCatalogProjectListResponse = {
    data: Array<TimesheetCatalogProject>;
};

export type TimesheetIssueLookupResponse = {
    data: {
        issueId: string;
        identifier: string;
        title: string;
        description: string | null;
        client: {
            id: string;
            name: string;
        } | null;
        application: {
            id: string;
            name: string;
        } | null;
        project: {
            id: string;
            name: string;
        } | null;
    };
};

export type AdminTimesheetUser = {
    id: string;
    firstName: string;
    lastName: string;
    workedDays: Array<number>;
    entries: Array<AdminTimesheetEntry>;
};

export type AdminTimesheetEntry = {
    id: string;
    entryDate: string;
    clientId: string;
    clientName: string;
    applicationId: string | null;
    applicationName: string | null;
    projectId: string | null;
    projectName: string | null;
    durationMinutes: number;
    durationHours: number;
    title: string | null;
    note: string | null;
    issueIdentifier: string | null;
    issueId: string | null;
    isMaintenance: boolean;
    createdAt: string;
    updatedAt: string;
    userId: string;
};

export type AdminTimesheetResponse = {
    data: {
        users: Array<AdminTimesheetUser>;
    };
};

export type TrackerProjects = {
    client: TrackerClient;
    projects: Array<TrackerProject>;
    applications: Array<TrackerApplication>;
};

export type TrackerClient = {
    id: string;
    name: string;
    logo: string | null;
};

export type TrackerProject = {
    id: string;
    name: string;
    icon: string | null;
    color: string | null;
    applicationId: string | null;
    applicationName: string | null;
    closedAt: string | null;
    isClosed: boolean;
    milestones: Array<TrackerMilestone>;
};

export type TrackerMilestone = {
    id: string;
    name: string;
    targetDate: string | null;
};

export type TrackerApplication = {
    id: string;
    name: string;
};

export type TrackerProjectsResponse = {
    data: TrackerProjects;
};

export type ProjectDocument = {
    id: string;
    name: string;
    mimeType: string;
    sizeBytes: number;
    category: string | null;
    visibleToClient: boolean;
    uploadedBy: string;
    isOwn: boolean;
    createdAt: string;
};

export type ProjectDocumentListResponse = {
    data: Array<ProjectDocument>;
};

export type ProjectDocumentResponse = {
    data: ProjectDocument;
};

export type ParticipantSuggestion = {
    participantId: string | null;
    userId: string | null;
    displayName: string;
    organization: string | null;
    isInternal: boolean;
};

export type ParticipantSuggestionListResponse = {
    data: Array<ParticipantSuggestion>;
};

export type MeetingDetail = {
    id: string;
    title: string;
    meetingDate: string;
    isInternal: boolean;
    visibility: 'private' | 'shared';
    projects: Array<MeetingTag>;
    applications: Array<MeetingTag>;
    summary: string | null;
    decisions: Array<MeetingDecision>;
    summaryStatus: 'pending' | 'processing' | 'ready' | 'failed';
    participants: Array<MeetingAttendee>;
    actions: Array<MeetingActionItem>;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    contentRevision: number;
    reviewedRevision: number | null;
    publishedVersion: number;
    publishedContentRevision: number | null;
    publishedAt: string | null;
    publicationState: 'draft' | 'reviewed' | 'published';
    hasUnpublishedChanges: boolean;
    clientId?: string;
    verbatim?: string;
    pendingSpeakers?: Array<MeetingPendingSpeaker>;
    summaryError?: string | null;
    summaryEditedAt?: string | null;
};

export type MeetingTag = {
    id: string;
    name: string;
};

export type MeetingDecision = {
    id: string;
    statement: string;
    topicKey: string | null;
    status: 'candidate' | 'confirmed' | 'superseded' | 'withdrawn';
    decidedByName: string | null;
    supersedesDecisionId: string | null;
    reviewedAt: string | null;
    evidence?: Array<MeetingEvidence>;
    revisions?: Array<MeetingDecisionRevision>;
};

export type MeetingEvidence = {
    speakerLabel: string | null;
    startTime: string | null;
    endTime: string | null;
    excerpt: string;
};

export type MeetingDecisionRevision = {
    id: string;
    statement: string;
    status: 'candidate' | 'confirmed' | 'superseded' | 'withdrawn';
    changeReason: string | null;
    createdAt: string;
};

export type MeetingAttendee = {
    id: string;
    participantId: string;
    displayName: string;
    organization: string | null;
    isInternal: boolean;
    isLinkedUser?: boolean;
    rawSpeakerLabels?: Array<string>;
};

export type MeetingActionItem = {
    id: string;
    title: string;
    description: string | null;
    suggestedPriority: number | null;
    category: 'technical' | 'design' | 'communication' | 'other';
    reviewStatus: 'candidate' | 'accepted' | 'rejected';
    workStatus: 'todo' | 'in_progress' | 'done' | 'cancelled';
    linkStatus: 'unlinked' | 'creating' | 'linked' | 'created';
    visibleToClient: boolean;
    linkedIssueIdentifier: string | null;
    assigneeName: string | null;
    linkedIssueId?: string | null;
    searchKeywords?: Array<string>;
    evidence?: Array<MeetingEvidence>;
};

export type MeetingPendingSpeaker = {
    speakerLabel: string;
    suggestedName: string | null;
    organization: string | null;
    isInternal: boolean;
    suggestedUserId?: string | null;
    suggestedParticipantId?: string | null;
};

export type MeetingDetailResponse = {
    data: MeetingDetail;
};

export type MeetingEvidenceBody = {
    speakerLabel: string | null;
    startTime: string | null;
    endTime: string | null;
    excerpt: string;
};

export type CreateMeetingDecisionBody = {
    statement: string;
    topicKey?: string | null;
    status?: 'candidate' | 'confirmed' | 'superseded' | 'withdrawn';
    decidedByParticipantId?: string | null;
    decidedBySpeakerLabel?: string | null;
    evidence?: Array<MeetingEvidenceBody>;
    supersedesDecisionId?: string | null;
    changeReason?: string | null;
};

export type UpdateMeetingDecisionBody = {
    statement?: string;
    topicKey?: string | null;
    status?: 'candidate' | 'confirmed' | 'superseded' | 'withdrawn';
    decidedByParticipantId?: string | null;
    decidedBySpeakerLabel?: string | null;
    evidence?: Array<MeetingEvidenceBody>;
    supersedesDecisionId?: string | null;
    changeReason?: string | null;
};

export type MeetingAttendeeInput = {
    participantId?: string;
    userId?: string | null;
    displayName: string;
    organization?: string | null;
    email?: string | null;
    isInternal?: boolean;
    rawSpeakerLabels?: Array<string>;
};

export type SetMeetingAttendeesBody = {
    attendees: Array<MeetingAttendeeInput>;
    ignoredSpeakerLabels?: Array<string>;
};

export type IssueCandidate = {
    id: string;
    identifier: string;
    title: string;
    stateName: string | null;
    url: string | null;
};

export type IssueCandidateListResponse = {
    data: Array<IssueCandidate>;
};

export type LinkMeetingActionItemBody = {
    issueId: string;
};

export type CreateIssueFromMeetingActionBody = {
    visibleToClient: boolean;
    priority?: number;
    projectId?: string;
};

export type UpdateMeetingActionItemBody = {
    title?: string;
    description?: string | null;
    suggestedPriority?: number | null;
    assigneeParticipantId?: string | null;
    visibleToClient?: boolean;
    reviewStatus?: 'candidate' | 'accepted' | 'rejected';
    workStatus?: 'todo' | 'in_progress' | 'done' | 'cancelled';
};

export type MeetingListItem = {
    id: string;
    title: string;
    meetingDate: string;
    isInternal: boolean;
    visibility: 'private' | 'shared';
    projects: Array<MeetingTag>;
    applications: Array<MeetingTag>;
    summaryStatus: 'pending' | 'processing' | 'ready' | 'failed';
    decisionCount: number;
    actionCount: number;
    participantNames: Array<string>;
    createdBy: string;
    createdAt: string;
    publicationState: 'draft' | 'reviewed' | 'published';
    hasUnpublishedChanges: boolean;
};

export type MeetingListResponse = {
    data: Array<MeetingListItem>;
};

export type CreateMeetingBody = {
    clientId?: string;
    projectIds?: Array<string>;
    applicationIds?: Array<string>;
    title: string;
    meetingDate: string;
    isInternal?: boolean;
    verbatim: string;
};

export type UpdateMeetingBody = {
    title?: string;
    meetingDate?: string;
    projectIds?: Array<string>;
    applicationIds?: Array<string>;
    summary?: string | null;
    isInternal?: boolean;
};

export const ErrorCode = {
    AUTH_REQUIRED: 'auth_required',
    AUTH_API_TOKEN_INVALID: 'auth_api_token_invalid',
    AUTH_API_TOKEN_READ_ONLY: 'auth_api_token_read_only',
    AUTH_NO_VALID_ROLE: 'auth_no_valid_role',
    AUTH_NO_CLIENT_ASSOCIATED: 'auth_no_client_associated',
    AUTH_FORBIDDEN: 'auth_forbidden',
    AUTH_OIDC_SESSION_REQUIRED: 'auth_oidc_session_required',
    RATE_LIMITED: 'rate_limited',
    VALIDATION_FAILED: 'validation_failed',
    ROUTE_NOT_FOUND: 'route_not_found',
    REQUEST_MALFORMED: 'request_malformed',
    REQUEST_TOO_LARGE: 'request_too_large',
    REQUEST_UNSUPPORTED_ENCODING: 'request_unsupported_encoding',
    SERVICE_UNAVAILABLE: 'service_unavailable',
    INTERNAL_ERROR: 'internal_error',
    CLIENT_NOT_FOUND: 'client_not_found',
    CLIENT_UNKNOWN: 'client_unknown',
    CLIENT_ISSUE_PREFIX_TAKEN: 'client_issue_prefix_taken',
    CLIENT_ISSUE_PREFIX_LOCKED: 'client_issue_prefix_locked',
    CLIENT_ISSUE_PREFIX_MISSING: 'client_issue_prefix_missing',
    USER_NOT_FOUND: 'user_not_found',
    USER_EMAIL_TAKEN: 'user_email_taken',
    USER_EMAIL_LINKED_TO_ANOTHER_ACCOUNT: 'user_email_linked_to_another_account',
    USER_EMAIL_IS_CLIENT_LOGIN: 'user_email_is_client_login',
    USER_ALREADY_EXISTS: 'user_already_exists',
    USER_DELETED_ACCOUNT_INCONSISTENT: 'user_deleted_account_inconsistent',
    USER_CANNOT_DISABLE_SELF: 'user_cannot_disable_self',
    USER_LAST_ACTIVE_ADMIN: 'user_last_active_admin',
    KEYCLOAK_UNAVAILABLE: 'keycloak_unavailable',
    KEYCLOAK_REALM_NOT_FOUND: 'keycloak_realm_not_found',
    API_TOKEN_NOT_FOUND: 'api_token_not_found',
    API_TOKEN_CLIENT_ACCOUNT_FORBIDDEN: 'api_token_client_account_forbidden',
    PROJECT_NOT_FOUND: 'project_not_found',
    PROJECT_UNKNOWN: 'project_unknown',
    PROJECT_CLOSED: 'project_closed',
    PROJECT_HAS_TIMESHEET_ENTRIES: 'project_has_timesheet_entries',
    PROJECT_HAS_ISSUES: 'project_has_issues',
    PROJECT_HAS_DOCUMENTS: 'project_has_documents',
    PROJECT_HAS_MEETINGS: 'project_has_meetings',
    APPLICATION_NOT_FOUND: 'application_not_found',
    APPLICATION_NOT_OF_CLIENT: 'application_not_of_client',
    APPLICATION_NAME_TAKEN: 'application_name_taken',
    APPLICATION_HAS_PROJECTS: 'application_has_projects',
    APPLICATION_HAS_MEETINGS: 'application_has_meetings',
    APPLICATION_HAS_TIMESHEET_ENTRIES: 'application_has_timesheet_entries',
    MILESTONE_NOT_FOUND: 'milestone_not_found',
    ISSUE_NOT_FOUND: 'issue_not_found',
    ISSUE_ASSIGNEE_NOT_FOUND: 'issue_assignee_not_found',
    ISSUE_COMMENT_NOT_FOUND: 'issue_comment_not_found',
    ISSUE_COMMENT_NOT_EDITABLE: 'issue_comment_not_editable',
    ISSUE_ATTACHMENT_NOT_FOUND: 'issue_attachment_not_found',
    ISSUE_ATTACHMENT_ALREADY_ATTACHED: 'issue_attachment_already_attached',
    ISSUE_PARENT_UNKNOWN: 'issue_parent_unknown',
    ISSUE_HIERARCHY_CIRCULAR: 'issue_hierarchy_circular',
    ISSUE_SUB_ISSUE_FORBIDDEN: 'issue_sub_issue_forbidden',
    ISSUE_LABEL_UNKNOWN: 'issue_label_unknown',
    FILE_TOO_LARGE: 'file_too_large',
    FILE_NOT_FOUND: 'file_not_found',
    FILE_SVG_NOT_ALLOWED: 'file_svg_not_allowed',
    REMOTE_IMAGE_ONLY_HTTP: 'remote_image_only_http',
    REMOTE_IMAGE_URL_WITH_CREDENTIALS: 'remote_image_url_with_credentials',
    REMOTE_IMAGE_HOST_NOT_ALLOWED: 'remote_image_host_not_allowed',
    REMOTE_IMAGE_URL_INVALID: 'remote_image_url_invalid',
    REMOTE_IMAGE_INVALID_REDIRECT: 'remote_image_invalid_redirect',
    REMOTE_IMAGE_UNREACHABLE: 'remote_image_unreachable',
    REMOTE_IMAGE_NOT_AN_IMAGE: 'remote_image_not_an_image',
    REMOTE_IMAGE_TOO_MANY_REDIRECTS: 'remote_image_too_many_redirects',
    REMOTE_IMAGE_HTTP_ERROR: 'remote_image_http_error',
    DOCUMENT_NOT_FOUND: 'document_not_found',
    DOCUMENT_NOT_OWNED: 'document_not_owned',
    DOCUMENT_TOO_LARGE: 'document_too_large',
    DOCUMENT_PROJECT_CLOSED: 'document_project_closed',
    TIMESHEET_ENTRY_NOT_FOUND: 'timesheet_entry_not_found',
    TIMESHEET_PROJECT_NOT_OF_CLIENT: 'timesheet_project_not_of_client',
    TIMESHEET_APPLICATION_PROJECT_MISMATCH: 'timesheet_application_project_mismatch',
    TIMESHEET_PROJECT_CLOSED: 'timesheet_project_closed',
    GITLAB_WEBHOOK_NOT_CONFIGURED: 'gitlab_webhook_not_configured',
    GITLAB_WEBHOOK_TOKEN_INVALID: 'gitlab_webhook_token_invalid',
    GITLAB_DASHBOARD_CLIENT_FORBIDDEN: 'gitlab_dashboard_client_forbidden',
    GITLAB_TOKEN_MANAGEMENT_CLIENT_FORBIDDEN: 'gitlab_token_management_client_forbidden',
    GITLAB_TOKEN_NOT_CONFIGURED: 'gitlab_token_not_configured',
    GITLAB_TOKEN_REJECTED: 'gitlab_token_rejected',
    GITLAB_TOKEN_SCOPE_INSUFFICIENT: 'gitlab_token_scope_insufficient',
    GITLAB_TOKEN_INVALID: 'gitlab_token_invalid',
    GITLAB_UNAVAILABLE: 'gitlab_unavailable',
    GITLAB_INTEGRATION_NOT_CONFIGURED: 'gitlab_integration_not_configured',
    GITLAB_API_ERROR: 'gitlab_api_error',
    LINK_NOT_FOUND: 'link_not_found',
    LINK_CATEGORY_NOT_FOUND: 'link_category_not_found',
    LINK_CATEGORY_ALREADY_EXISTS: 'link_category_already_exists',
    LINK_CATEGORY_UNKNOWN: 'link_category_unknown',
    MEETING_NOT_FOUND: 'meeting_not_found',
    MEETING_DECISION_NOT_FOUND: 'meeting_decision_not_found',
    MEETING_ACTION_NOT_FOUND: 'meeting_action_not_found',
    MEETING_PARTICIPANT_NOT_FOUND: 'meeting_participant_not_found',
    MEETING_CONTENT_CHANGED: 'meeting_content_changed',
    MEETING_SUMMARY_IN_PROGRESS: 'meeting_summary_in_progress',
    MEETING_SUMMARIZER_NOT_CONFIGURED: 'meeting_summarizer_not_configured',
    MEETING_VERBATIM_TOO_LONG: 'meeting_verbatim_too_long',
    MEETING_DELETE_SHARED_ADMIN_ONLY: 'meeting_delete_shared_admin_only',
    MEETING_DELETE_LINKED_ADMIN_ONLY: 'meeting_delete_linked_admin_only',
    MEETING_REVIEW_CANDIDATES_PENDING: 'meeting_review_candidates_pending',
    MEETING_REVIEW_NOT_READY: 'meeting_review_not_ready',
    MEETING_PUBLISH_STALE: 'meeting_publish_stale',
    MEETING_DECISION_SUPERSEDES_INVALID: 'meeting_decision_supersedes_invalid',
    MEETING_CANDIDATES_SEARCH_FAILED: 'meeting_candidates_search_failed',
    MEETING_ACTION_LINK_NOT_ACCEPTED: 'meeting_action_link_not_accepted',
    MEETING_ACTION_ALREADY_LINKED: 'meeting_action_already_linked',
    MEETING_ACTION_LINK_CONFLICT: 'meeting_action_link_conflict',
    MEETING_ACTION_CREATE_NOT_ACCEPTED: 'meeting_action_create_not_accepted',
    MEETING_ACTION_ISSUE_ALREADY_CREATED: 'meeting_action_issue_already_created',
    MEETING_ACTION_ISSUE_CREATION_IN_PROGRESS: 'meeting_action_issue_creation_in_progress',
    MEETING_ACTION_CONTENT_FROZEN: 'meeting_action_content_frozen',
    MEETING_ACTION_VISIBILITY_FROZEN: 'meeting_action_visibility_frozen',
    MEETING_ACTION_LINKED_CANNOT_REJECT: 'meeting_action_linked_cannot_reject',
    MEETING_ACTION_NOT_ACCEPTED_FOR_WORK: 'meeting_action_not_accepted_for_work',
    MEETING_ACTION_CHANGED: 'meeting_action_changed',
    MEETING_ACTION_TARGET_NO_PROJECT: 'meeting_action_target_no_project',
    MEETING_ACTION_TARGET_PROJECT_NOT_TAGGED: 'meeting_action_target_project_not_tagged',
    MEETING_ACTION_TARGET_PROJECT_AMBIGUOUS: 'meeting_action_target_project_ambiguous',
    MEETING_ACTION_TARGET_PROJECT_NOT_FOUND: 'meeting_action_target_project_not_found',
    MEETING_ACTION_ISSUE_CREATION_FAILED: 'meeting_action_issue_creation_failed'
} as const;

export type ErrorCode = typeof ErrorCode[keyof typeof ErrorCode];

export type ApiErrorBody = {
    statusCode: number;
    statusMessage: string;
    message: string;
    code: ErrorCode;
    params?: {
        [key: string]: string | number;
    };
};

export type GetMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/me';
};

export type GetMeErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetMeError = GetMeErrors[keyof GetMeErrors];

export type GetMeResponses = {
    200: MeResponse;
};

export type GetMeResponse = GetMeResponses[keyof GetMeResponses];

export type ListMyApiTokensData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/profile/tokens';
};

export type ListMyApiTokensErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListMyApiTokensError = ListMyApiTokensErrors[keyof ListMyApiTokensErrors];

export type ListMyApiTokensResponses = {
    200: ApiTokenListResponse;
};

export type ListMyApiTokensResponse = ListMyApiTokensResponses[keyof ListMyApiTokensResponses];

export type CreateApiTokenData = {
    body: CreateApiTokenBody;
    path?: never;
    query?: never;
    url: '/api/profile/tokens';
};

export type CreateApiTokenErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateApiTokenError = CreateApiTokenErrors[keyof CreateApiTokenErrors];

export type CreateApiTokenResponses = {
    201: CreatedApiTokenResponse;
};

export type CreateApiTokenResponse = CreateApiTokenResponses[keyof CreateApiTokenResponses];

export type RevokeMyApiTokenData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/profile/tokens/{id}';
};

export type RevokeMyApiTokenErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type RevokeMyApiTokenError = RevokeMyApiTokenErrors[keyof RevokeMyApiTokenErrors];

export type RevokeMyApiTokenResponses = {
    200: SuccessResponse;
};

export type RevokeMyApiTokenResponse = RevokeMyApiTokenResponses[keyof RevokeMyApiTokenResponses];

export type ListAllApiTokensData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/admin/api-tokens';
};

export type ListAllApiTokensErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListAllApiTokensError = ListAllApiTokensErrors[keyof ListAllApiTokensErrors];

export type ListAllApiTokensResponses = {
    200: AdminApiTokenListResponse;
};

export type ListAllApiTokensResponse = ListAllApiTokensResponses[keyof ListAllApiTokensResponses];

export type RevokeApiTokenAsAdminData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/api-tokens/{id}';
};

export type RevokeApiTokenAsAdminErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type RevokeApiTokenAsAdminError = RevokeApiTokenAsAdminErrors[keyof RevokeApiTokenAsAdminErrors];

export type RevokeApiTokenAsAdminResponses = {
    200: SuccessResponse;
};

export type RevokeApiTokenAsAdminResponse = RevokeApiTokenAsAdminResponses[keyof RevokeApiTokenAsAdminResponses];

export type ListInternalUsersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/admin/users';
};

export type ListInternalUsersErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListInternalUsersError = ListInternalUsersErrors[keyof ListInternalUsersErrors];

export type ListInternalUsersResponses = {
    200: InternalUserListResponse;
};

export type ListInternalUsersResponse = ListInternalUsersResponses[keyof ListInternalUsersResponses];

export type CreateInternalUserData = {
    body: CreateInternalUserBody;
    path?: never;
    query?: never;
    url: '/api/admin/users';
};

export type CreateInternalUserErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateInternalUserError = CreateInternalUserErrors[keyof CreateInternalUserErrors];

export type CreateInternalUserResponses = {
    201: CreatedInternalUserResponse;
};

export type CreateInternalUserResponse = CreateInternalUserResponses[keyof CreateInternalUserResponses];

export type UpdateInternalUserData = {
    body: UpdateInternalUserBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/users/{id}';
};

export type UpdateInternalUserErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateInternalUserError = UpdateInternalUserErrors[keyof UpdateInternalUserErrors];

export type UpdateInternalUserResponses = {
    200: InternalUserProfileResponse;
};

export type UpdateInternalUserResponse = UpdateInternalUserResponses[keyof UpdateInternalUserResponses];

export type SetInternalUserRoleData = {
    body: SetInternalUserRoleBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/users/{id}/role';
};

export type SetInternalUserRoleErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetInternalUserRoleError = SetInternalUserRoleErrors[keyof SetInternalUserRoleErrors];

export type SetInternalUserRoleResponses = {
    200: InternalUserRoleResponse;
};

export type SetInternalUserRoleResponse = SetInternalUserRoleResponses[keyof SetInternalUserRoleResponses];

export type SetInternalUserEnabledData = {
    body: SetInternalUserEnabledBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/users/{id}/enabled';
};

export type SetInternalUserEnabledErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetInternalUserEnabledError = SetInternalUserEnabledErrors[keyof SetInternalUserEnabledErrors];

export type SetInternalUserEnabledResponses = {
    200: InternalUserEnabledResponse;
};

export type SetInternalUserEnabledResponse = SetInternalUserEnabledResponses[keyof SetInternalUserEnabledResponses];

export type ResetInternalUserPasswordData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/users/{id}/reset-password';
};

export type ResetInternalUserPasswordErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ResetInternalUserPasswordError = ResetInternalUserPasswordErrors[keyof ResetInternalUserPasswordErrors];

export type ResetInternalUserPasswordResponses = {
    200: ResetPasswordResponse;
};

export type ResetInternalUserPasswordResponse = ResetInternalUserPasswordResponses[keyof ResetInternalUserPasswordResponses];

export type ListInternalDirectoryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/users/internal';
};

export type ListInternalDirectoryErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListInternalDirectoryError = ListInternalDirectoryErrors[keyof ListInternalDirectoryErrors];

export type ListInternalDirectoryResponses = {
    200: InternalDirectoryResponse;
};

export type ListInternalDirectoryResponse = ListInternalDirectoryResponses[keyof ListInternalDirectoryResponses];

export type LivenessData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/health';
};

export type LivenessErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type LivenessError = LivenessErrors[keyof LivenessErrors];

export type LivenessResponses = {
    200: unknown;
};

export type ReadinessData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/health/ready';
};

export type ReadinessErrors = {
    /**
     * The Health Check is not successful
     */
    503: {
        status?: string;
        info?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        error?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        details?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        };
    };
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ReadinessError = ReadinessErrors[keyof ReadinessErrors];

export type ReadinessResponses = {
    /**
     * The Health Check is successful
     */
    200: {
        status?: string;
        info?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        error?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        details?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        };
    };
};

export type ReadinessResponse = ReadinessResponses[keyof ReadinessResponses];

export type ListClientsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/admin/clients';
};

export type ListClientsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListClientsError = ListClientsErrors[keyof ListClientsErrors];

export type ListClientsResponses = {
    200: AdminClientListResponse;
};

export type ListClientsResponse = ListClientsResponses[keyof ListClientsResponses];

export type CreateClientData = {
    body: CreateClientBody;
    path?: never;
    query?: never;
    url: '/api/admin/clients';
};

export type CreateClientErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateClientError = CreateClientErrors[keyof CreateClientErrors];

export type CreateClientResponses = {
    201: AdminClientResponse;
};

export type CreateClientResponse = CreateClientResponses[keyof CreateClientResponses];

export type GetClientData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}';
};

export type GetClientErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetClientError = GetClientErrors[keyof GetClientErrors];

export type GetClientResponses = {
    200: AdminClientResponse;
};

export type GetClientResponse = GetClientResponses[keyof GetClientResponses];

export type UpdateClientData = {
    body: UpdateClientBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}';
};

export type UpdateClientErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateClientError = UpdateClientErrors[keyof UpdateClientErrors];

export type UpdateClientResponses = {
    200: AdminClientResponse;
};

export type UpdateClientResponse = UpdateClientResponses[keyof UpdateClientResponses];

export type ActivateClientData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/activate';
};

export type ActivateClientErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ActivateClientError = ActivateClientErrors[keyof ActivateClientErrors];

export type ActivateClientResponses = {
    200: ClientStatusChangeResponse;
};

export type ActivateClientResponse = ActivateClientResponses[keyof ActivateClientResponses];

export type DeactivateClientData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/deactivate';
};

export type DeactivateClientErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeactivateClientError = DeactivateClientErrors[keyof DeactivateClientErrors];

export type DeactivateClientResponses = {
    200: ClientStatusChangeResponse;
};

export type DeactivateClientResponse = DeactivateClientResponses[keyof DeactivateClientResponses];

export type EnableClientPortalData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/enable-portal';
};

export type EnableClientPortalErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type EnableClientPortalError = EnableClientPortalErrors[keyof EnableClientPortalErrors];

export type EnableClientPortalResponses = {
    200: AdminClientResponse;
};

export type EnableClientPortalResponse = EnableClientPortalResponses[keyof EnableClientPortalResponses];

export type ListClientUsersData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/users';
};

export type ListClientUsersErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListClientUsersError = ListClientUsersErrors[keyof ListClientUsersErrors];

export type ListClientUsersResponses = {
    200: ClientUserListResponse;
};

export type ListClientUsersResponse = ListClientUsersResponses[keyof ListClientUsersResponses];

export type CreateClientUserData = {
    body: CreateClientUserBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/users';
};

export type CreateClientUserErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateClientUserError = CreateClientUserErrors[keyof CreateClientUserErrors];

export type CreateClientUserResponses = {
    201: CreatedClientUserResponse;
};

export type CreateClientUserResponse = CreateClientUserResponses[keyof CreateClientUserResponses];

export type DeleteClientUserData = {
    body?: never;
    path: {
        id: string;
        userId: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/users/{userId}';
};

export type DeleteClientUserErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteClientUserError = DeleteClientUserErrors[keyof DeleteClientUserErrors];

export type DeleteClientUserResponses = {
    200: DeleteClientUserResponse;
};

export type DeleteClientUserResponse2 = DeleteClientUserResponses[keyof DeleteClientUserResponses];

export type UpdateClientUserData = {
    body: UpdateClientUserBody;
    path: {
        id: string;
        userId: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/users/{userId}';
};

export type UpdateClientUserErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateClientUserError = UpdateClientUserErrors[keyof UpdateClientUserErrors];

export type UpdateClientUserResponses = {
    200: ClientUserResponse;
};

export type UpdateClientUserResponse = UpdateClientUserResponses[keyof UpdateClientUserResponses];

export type ResetClientUserPasswordData = {
    body?: never;
    path: {
        id: string;
        userId: string;
    };
    query?: never;
    url: '/api/admin/clients/{id}/users/{userId}/reset-password';
};

export type ResetClientUserPasswordErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ResetClientUserPasswordError = ResetClientUserPasswordErrors[keyof ResetClientUserPasswordErrors];

export type ResetClientUserPasswordResponses = {
    200: ResetPasswordResponse;
};

export type ResetClientUserPasswordResponse = ResetClientUserPasswordResponses[keyof ResetClientUserPasswordResponses];

export type ListPortalClientsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/clients';
};

export type ListPortalClientsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListPortalClientsError = ListPortalClientsErrors[keyof ListPortalClientsErrors];

export type ListPortalClientsResponses = {
    200: AdminClientListResponse;
};

export type ListPortalClientsResponse = ListPortalClientsResponses[keyof ListPortalClientsResponses];

export type GetMyClientData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/clients/me';
};

export type GetMyClientErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetMyClientError = GetMyClientErrors[keyof GetMyClientErrors];

export type GetMyClientResponses = {
    200: MyClientResponse;
};

export type GetMyClientResponse = GetMyClientResponses[keyof GetMyClientResponses];

export type ListLinksData = {
    body?: never;
    path?: never;
    query?: {
        categoryId?: string;
        clientId?: string;
    };
    url: '/api/links';
};

export type ListLinksErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListLinksError = ListLinksErrors[keyof ListLinksErrors];

export type ListLinksResponses = {
    200: LinkListResponse;
};

export type ListLinksResponse = ListLinksResponses[keyof ListLinksResponses];

export type CreateLinkData = {
    body: CreateLinkBody;
    path?: never;
    query?: never;
    url: '/api/links';
};

export type CreateLinkErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateLinkError = CreateLinkErrors[keyof CreateLinkErrors];

export type CreateLinkResponses = {
    201: LinkResponse;
};

export type CreateLinkResponse = CreateLinkResponses[keyof CreateLinkResponses];

export type DeleteLinkData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/links/{id}';
};

export type DeleteLinkErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteLinkError = DeleteLinkErrors[keyof DeleteLinkErrors];

export type DeleteLinkResponses = {
    200: LinkResponse;
};

export type DeleteLinkResponse = DeleteLinkResponses[keyof DeleteLinkResponses];

export type UpdateLinkData = {
    body: UpdateLinkBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/links/{id}';
};

export type UpdateLinkErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateLinkError = UpdateLinkErrors[keyof UpdateLinkErrors];

export type UpdateLinkResponses = {
    200: LinkResponse;
};

export type UpdateLinkResponse = UpdateLinkResponses[keyof UpdateLinkResponses];

export type ReorderLinksData = {
    body: ReorderLinksBody;
    path?: never;
    query?: never;
    url: '/api/links/reorder';
};

export type ReorderLinksErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ReorderLinksError = ReorderLinksErrors[keyof ReorderLinksErrors];

export type ReorderLinksResponses = {
    200: ReorderedLinksResponse;
};

export type ReorderLinksResponse = ReorderLinksResponses[keyof ReorderLinksResponses];

export type ListLinkCategoriesData = {
    body?: never;
    path?: never;
    query?: {
        clientId?: string;
    };
    url: '/api/link-categories';
};

export type ListLinkCategoriesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListLinkCategoriesError = ListLinkCategoriesErrors[keyof ListLinkCategoriesErrors];

export type ListLinkCategoriesResponses = {
    200: LinkCategoryListResponse;
};

export type ListLinkCategoriesResponse = ListLinkCategoriesResponses[keyof ListLinkCategoriesResponses];

export type CreateLinkCategoryData = {
    body: CreateLinkCategoryBody;
    path?: never;
    query?: never;
    url: '/api/link-categories';
};

export type CreateLinkCategoryErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateLinkCategoryError = CreateLinkCategoryErrors[keyof CreateLinkCategoryErrors];

export type CreateLinkCategoryResponses = {
    201: LinkCategoryResponse;
};

export type CreateLinkCategoryResponse = CreateLinkCategoryResponses[keyof CreateLinkCategoryResponses];

export type DeleteLinkCategoryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/link-categories/{id}';
};

export type DeleteLinkCategoryErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteLinkCategoryError = DeleteLinkCategoryErrors[keyof DeleteLinkCategoryErrors];

export type DeleteLinkCategoryResponses = {
    200: LinkCategoryResponse;
};

export type DeleteLinkCategoryResponse = DeleteLinkCategoryResponses[keyof DeleteLinkCategoryResponses];

export type UpdateLinkCategoryData = {
    body: UpdateLinkCategoryBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/link-categories/{id}';
};

export type UpdateLinkCategoryErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateLinkCategoryError = UpdateLinkCategoryErrors[keyof UpdateLinkCategoryErrors];

export type UpdateLinkCategoryResponses = {
    200: LinkCategoryResponse;
};

export type UpdateLinkCategoryResponse = UpdateLinkCategoryResponses[keyof UpdateLinkCategoryResponses];

export type ReorderLinkCategoriesData = {
    body: ReorderLinkCategoriesBody;
    path?: never;
    query?: never;
    url: '/api/link-categories/reorder';
};

export type ReorderLinkCategoriesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ReorderLinkCategoriesError = ReorderLinkCategoriesErrors[keyof ReorderLinkCategoriesErrors];

export type ReorderLinkCategoriesResponses = {
    200: LinkCategoryListResponse;
};

export type ReorderLinkCategoriesResponse = ReorderLinkCategoriesResponses[keyof ReorderLinkCategoriesResponses];

export type ListProjectOverviewData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/admin/projects';
};

export type ListProjectOverviewErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListProjectOverviewError = ListProjectOverviewErrors[keyof ListProjectOverviewErrors];

export type ListProjectOverviewResponses = {
    200: ProjectOverviewListResponse;
};

export type ListProjectOverviewResponse = ListProjectOverviewResponses[keyof ListProjectOverviewResponses];

export type CreateProjectData = {
    body: CreateProjectBody;
    path?: never;
    query?: never;
    url: '/api/admin/projects';
};

export type CreateProjectErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateProjectError = CreateProjectErrors[keyof CreateProjectErrors];

export type CreateProjectResponses = {
    201: CreatedProjectResponse;
};

export type CreateProjectResponse = CreateProjectResponses[keyof CreateProjectResponses];

export type DeleteProjectData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/projects/{id}';
};

export type DeleteProjectErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteProjectError = DeleteProjectErrors[keyof DeleteProjectErrors];

export type DeleteProjectResponses = {
    200: SuccessResponse;
};

export type DeleteProjectResponse = DeleteProjectResponses[keyof DeleteProjectResponses];

export type SetProjectBudgetData = {
    body: ProjectBudgetBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/projects/{id}';
};

export type SetProjectBudgetErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetProjectBudgetError = SetProjectBudgetErrors[keyof SetProjectBudgetErrors];

export type SetProjectBudgetResponses = {
    200: ProjectBudgetResponse;
};

export type SetProjectBudgetResponse = SetProjectBudgetResponses[keyof SetProjectBudgetResponses];

export type UpdateProjectDetailsData = {
    body: UpdateProjectDetailsBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/projects/{id}/details';
};

export type UpdateProjectDetailsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateProjectDetailsError = UpdateProjectDetailsErrors[keyof UpdateProjectDetailsErrors];

export type UpdateProjectDetailsResponses = {
    200: ProjectDetailsResponse;
};

export type UpdateProjectDetailsResponse = UpdateProjectDetailsResponses[keyof UpdateProjectDetailsResponses];

export type SetProjectClosureData = {
    body: ProjectClosureBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/projects/{id}/closure';
};

export type SetProjectClosureErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetProjectClosureError = SetProjectClosureErrors[keyof SetProjectClosureErrors];

export type SetProjectClosureResponses = {
    200: ProjectClosureResponse;
};

export type SetProjectClosureResponse = SetProjectClosureResponses[keyof SetProjectClosureResponses];

export type ListProjectMilestonesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/projects/{id}/milestones';
};

export type ListProjectMilestonesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListProjectMilestonesError = ListProjectMilestonesErrors[keyof ListProjectMilestonesErrors];

export type ListProjectMilestonesResponses = {
    200: MilestoneListResponse;
};

export type ListProjectMilestonesResponse = ListProjectMilestonesResponses[keyof ListProjectMilestonesResponses];

export type CreateProjectMilestoneData = {
    body: CreateMilestoneBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/projects/{id}/milestones';
};

export type CreateProjectMilestoneErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateProjectMilestoneError = CreateProjectMilestoneErrors[keyof CreateProjectMilestoneErrors];

export type CreateProjectMilestoneResponses = {
    201: MilestoneResponse;
};

export type CreateProjectMilestoneResponse = CreateProjectMilestoneResponses[keyof CreateProjectMilestoneResponses];

export type ListApplicationsData = {
    body?: never;
    path?: never;
    query?: {
        clientId?: string;
    };
    url: '/api/admin/applications';
};

export type ListApplicationsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListApplicationsError = ListApplicationsErrors[keyof ListApplicationsErrors];

export type ListApplicationsResponses = {
    200: ApplicationListResponse;
};

export type ListApplicationsResponse = ListApplicationsResponses[keyof ListApplicationsResponses];

export type CreateApplicationData = {
    body: CreateApplicationBody;
    path?: never;
    query?: never;
    url: '/api/admin/applications';
};

export type CreateApplicationErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateApplicationError = CreateApplicationErrors[keyof CreateApplicationErrors];

export type CreateApplicationResponses = {
    201: CreatedApplicationResponse;
};

export type CreateApplicationResponse = CreateApplicationResponses[keyof CreateApplicationResponses];

export type DeleteApplicationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/applications/{id}';
};

export type DeleteApplicationErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteApplicationError = DeleteApplicationErrors[keyof DeleteApplicationErrors];

export type DeleteApplicationResponses = {
    200: SuccessResponse;
};

export type DeleteApplicationResponse = DeleteApplicationResponses[keyof DeleteApplicationResponses];

export type UpdateApplicationData = {
    body: UpdateApplicationBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/applications/{id}';
};

export type UpdateApplicationErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateApplicationError = UpdateApplicationErrors[keyof UpdateApplicationErrors];

export type UpdateApplicationResponses = {
    200: CreatedApplicationResponse;
};

export type UpdateApplicationResponse = UpdateApplicationResponses[keyof UpdateApplicationResponses];

export type DeleteMilestoneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/milestones/{id}';
};

export type DeleteMilestoneErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteMilestoneError = DeleteMilestoneErrors[keyof DeleteMilestoneErrors];

export type DeleteMilestoneResponses = {
    200: SuccessResponse;
};

export type DeleteMilestoneResponse = DeleteMilestoneResponses[keyof DeleteMilestoneResponses];

export type UpdateMilestoneData = {
    body: UpdateMilestoneBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/admin/milestones/{id}';
};

export type UpdateMilestoneErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateMilestoneError = UpdateMilestoneErrors[keyof UpdateMilestoneErrors];

export type UpdateMilestoneResponses = {
    200: MilestoneResponse;
};

export type UpdateMilestoneResponse = UpdateMilestoneResponses[keyof UpdateMilestoneResponses];

export type ListClientProjectsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Client ciblé — obligatoire pour un rôle interne, ignoré pour le rôle client.
         */
        clientId?: string;
    };
    url: '/api/projects';
};

export type ListClientProjectsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListClientProjectsError = ListClientProjectsErrors[keyof ListClientProjectsErrors];

export type ListClientProjectsResponses = {
    200: ClientProjectListResponse;
};

export type ListClientProjectsResponse = ListClientProjectsResponses[keyof ListClientProjectsResponses];

export type UploadFileData = {
    body: {
        file: Blob | File;
        clientId?: string;
    };
    path?: never;
    query?: never;
    url: '/api/upload';
};

export type UploadFileErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UploadFileError = UploadFileErrors[keyof UploadFileErrors];

export type UploadFileResponses = {
    200: UploadResponse;
};

export type UploadFileResponse = UploadFileResponses[keyof UploadFileResponses];

export type ImportFileFromUrlData = {
    body: ImportUrlBody;
    path?: never;
    query?: never;
    url: '/api/upload/import-url';
};

export type ImportFileFromUrlErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ImportFileFromUrlError = ImportFileFromUrlErrors[keyof ImportFileFromUrlErrors];

export type ImportFileFromUrlResponses = {
    200: UploadResponse;
};

export type ImportFileFromUrlResponse = ImportFileFromUrlResponses[keyof ImportFileFromUrlResponses];

export type DownloadFileData = {
    body?: never;
    path: {
        path: string | Array<string>;
    };
    query?: never;
    url: '/api/files/{path}';
};

export type DownloadFileErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DownloadFileError = DownloadFileErrors[keyof DownloadFileErrors];

export type DownloadFileResponses = {
    /**
     * Flux binaire de l'objet stocké (Content-Type et Content-Disposition selon le type réel).
     */
    200: Blob | File;
};

export type DownloadFileResponse = DownloadFileResponses[keyof DownloadFileResponses];

export type LookupIssuesData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        /**
         * Client dans lequel chercher (obligatoire : la recherche est scopée).
         */
        clientId: string;
    };
    url: '/api/issues/lookup';
};

export type LookupIssuesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type LookupIssuesError = LookupIssuesErrors[keyof LookupIssuesErrors];

export type LookupIssuesResponses = {
    200: IssueLookupListResponse;
};

export type LookupIssuesResponse = LookupIssuesResponses[keyof LookupIssuesResponses];

export type ResolveIssueIdentifierData = {
    body?: never;
    path?: never;
    query: {
        identifier: string;
    };
    url: '/api/issues/resolve';
};

export type ResolveIssueIdentifierErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ResolveIssueIdentifierError = ResolveIssueIdentifierErrors[keyof ResolveIssueIdentifierErrors];

export type ResolveIssueIdentifierResponses = {
    200: IssueResolveResponse;
};

export type ResolveIssueIdentifierResponse = ResolveIssueIdentifierResponses[keyof ResolveIssueIdentifierResponses];

export type ListIssuesData = {
    body?: never;
    path?: never;
    query?: {
        scope?: 'all';
        /**
         * Client ciblé — obligatoire pour un rôle interne, ignoré pour le rôle client.
         */
        clientId?: string;
    };
    url: '/api/issues';
};

export type ListIssuesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListIssuesError = ListIssuesErrors[keyof ListIssuesErrors];

export type ListIssuesResponses = {
    200: IssueListResponse;
};

export type ListIssuesResponse = ListIssuesResponses[keyof ListIssuesResponses];

export type CreateIssueData = {
    body: CreateIssueBody;
    path?: never;
    query?: never;
    url: '/api/issues';
};

export type CreateIssueErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateIssueError = CreateIssueErrors[keyof CreateIssueErrors];

export type CreateIssueResponses = {
    200: IssueRefResponse;
};

export type CreateIssueResponse = CreateIssueResponses[keyof CreateIssueResponses];

export type DeleteIssueData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}';
};

export type DeleteIssueErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteIssueError = DeleteIssueErrors[keyof DeleteIssueErrors];

export type DeleteIssueResponses = {
    200: DeletedIssueResponse;
};

export type DeleteIssueResponse = DeleteIssueResponses[keyof DeleteIssueResponses];

export type GetIssueData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        view?: 'client';
    };
    url: '/api/issues/{id}';
};

export type GetIssueErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetIssueError = GetIssueErrors[keyof GetIssueErrors];

export type GetIssueResponses = {
    200: IssueDetailResponse;
};

export type GetIssueResponse = GetIssueResponses[keyof GetIssueResponses];

export type UpdateIssueData = {
    body: UpdateIssueBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}';
};

export type UpdateIssueErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateIssueError = UpdateIssueErrors[keyof UpdateIssueErrors];

export type UpdateIssueResponses = {
    200: IssueRefResponse;
};

export type UpdateIssueResponse = UpdateIssueResponses[keyof UpdateIssueResponses];

export type SetIssueStateData = {
    body: IssueStateBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}/state';
};

export type SetIssueStateErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetIssueStateError = SetIssueStateErrors[keyof SetIssueStateErrors];

export type SetIssueStateResponses = {
    200: IssueStateResponse;
};

export type SetIssueStateResponse = SetIssueStateResponses[keyof SetIssueStateResponses];

export type SetIssueAssigneeData = {
    body: IssueAssignmentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}/assignment';
};

export type SetIssueAssigneeErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetIssueAssigneeError = SetIssueAssigneeErrors[keyof SetIssueAssigneeErrors];

export type SetIssueAssigneeResponses = {
    200: IssueAssignmentResponse;
};

export type SetIssueAssigneeResponse = SetIssueAssigneeResponses[keyof SetIssueAssigneeResponses];

export type SetIssueFlagsData = {
    body: IssueFlagsBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}/flags';
};

export type SetIssueFlagsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetIssueFlagsError = SetIssueFlagsErrors[keyof SetIssueFlagsErrors];

export type SetIssueFlagsResponses = {
    200: IssueFlagsResponse;
};

export type SetIssueFlagsResponse = SetIssueFlagsResponses[keyof SetIssueFlagsResponses];

export type SetIssueParentData = {
    body: IssueParentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}/parent';
};

export type SetIssueParentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetIssueParentError = SetIssueParentErrors[keyof SetIssueParentErrors];

export type SetIssueParentResponses = {
    200: IssueParentResponse;
};

export type SetIssueParentResponse = SetIssueParentResponses[keyof SetIssueParentResponses];

export type SetIssueValidationData = {
    body: IssueValidationBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}/validation';
};

export type SetIssueValidationErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetIssueValidationError = SetIssueValidationErrors[keyof SetIssueValidationErrors];

export type SetIssueValidationResponses = {
    200: IssueValidationResponse;
};

export type SetIssueValidationResponse = SetIssueValidationResponses[keyof SetIssueValidationResponses];

export type ListIssueMergeRequestsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}/merge-requests';
};

export type ListIssueMergeRequestsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListIssueMergeRequestsError = ListIssueMergeRequestsErrors[keyof ListIssueMergeRequestsErrors];

export type ListIssueMergeRequestsResponses = {
    200: IssueMergeRequestListResponse;
};

export type ListIssueMergeRequestsResponse = ListIssueMergeRequestsResponses[keyof ListIssueMergeRequestsResponses];

export type CreateIssueCommentData = {
    body: IssueCommentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/issues/{id}/comments';
};

export type CreateIssueCommentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateIssueCommentError = CreateIssueCommentErrors[keyof CreateIssueCommentErrors];

export type CreateIssueCommentResponses = {
    200: IssueCommentRefResponse;
};

export type CreateIssueCommentResponse = CreateIssueCommentResponses[keyof CreateIssueCommentResponses];

export type UpdateIssueCommentData = {
    body: IssueCommentBody;
    path: {
        id: string;
        commentId: string;
    };
    query?: never;
    url: '/api/issues/{id}/comments/{commentId}';
};

export type UpdateIssueCommentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateIssueCommentError = UpdateIssueCommentErrors[keyof UpdateIssueCommentErrors];

export type UpdateIssueCommentResponses = {
    200: IssueCommentRefResponse;
};

export type UpdateIssueCommentResponse = UpdateIssueCommentResponses[keyof UpdateIssueCommentResponses];

export type CreateAttachmentData = {
    body: CreateAttachmentBody;
    path?: never;
    query?: never;
    url: '/api/attachments';
};

export type CreateAttachmentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateAttachmentError = CreateAttachmentErrors[keyof CreateAttachmentErrors];

export type CreateAttachmentResponses = {
    200: AttachmentResponse;
};

export type CreateAttachmentResponse = CreateAttachmentResponses[keyof CreateAttachmentResponses];

export type DeleteAttachmentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/attachments/{id}';
};

export type DeleteAttachmentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteAttachmentError = DeleteAttachmentErrors[keyof DeleteAttachmentErrors];

export type DeleteAttachmentResponses = {
    200: SuccessResponse;
};

export type DeleteAttachmentResponse = DeleteAttachmentResponses[keyof DeleteAttachmentResponses];

export type DownloadAttachmentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/attachments/{id}/download';
};

export type DownloadAttachmentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DownloadAttachmentError = DownloadAttachmentErrors[keyof DownloadAttachmentErrors];

export type DownloadAttachmentResponses = {
    /**
     * Flux binaire de la pièce jointe (toujours en téléchargement, jamais en inline).
     */
    200: Blob | File;
};

export type DownloadAttachmentResponse = DownloadAttachmentResponses[keyof DownloadAttachmentResponses];

export type ListClientLabelsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Client ciblé — obligatoire pour un rôle interne, ignoré pour le rôle client.
         */
        clientId?: string;
    };
    url: '/api/labels';
};

export type ListClientLabelsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListClientLabelsError = ListClientLabelsErrors[keyof ListClientLabelsErrors];

export type ListClientLabelsResponses = {
    200: LabelListResponse;
};

export type ListClientLabelsResponse = ListClientLabelsResponses[keyof ListClientLabelsResponses];

export type HandleGitlabWebhookData = {
    body: GitlabWebhookBody;
    path?: never;
    query?: never;
    url: '/api/webhooks/gitlab';
};

export type HandleGitlabWebhookErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type HandleGitlabWebhookError = HandleGitlabWebhookErrors[keyof HandleGitlabWebhookErrors];

export type HandleGitlabWebhookResponses = {
    200: GitlabWebhookResponse;
};

export type HandleGitlabWebhookResponse = HandleGitlabWebhookResponses[keyof HandleGitlabWebhookResponses];

export type ListGitlabMergeRequestsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/gitlab/merge-requests';
};

export type ListGitlabMergeRequestsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListGitlabMergeRequestsError = ListGitlabMergeRequestsErrors[keyof ListGitlabMergeRequestsErrors];

export type ListGitlabMergeRequestsResponses = {
    200: GitlabDashboardResponse;
};

export type ListGitlabMergeRequestsResponse = ListGitlabMergeRequestsResponses[keyof ListGitlabMergeRequestsResponses];

export type DeleteGitlabTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/profile/gitlab-token';
};

export type DeleteGitlabTokenErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteGitlabTokenError = DeleteGitlabTokenErrors[keyof DeleteGitlabTokenErrors];

export type DeleteGitlabTokenResponses = {
    200: GitlabTokenDeletedResponse;
};

export type DeleteGitlabTokenResponse = DeleteGitlabTokenResponses[keyof DeleteGitlabTokenResponses];

export type GetGitlabTokenStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/profile/gitlab-token';
};

export type GetGitlabTokenStatusErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetGitlabTokenStatusError = GetGitlabTokenStatusErrors[keyof GetGitlabTokenStatusErrors];

export type GetGitlabTokenStatusResponses = {
    200: GitlabTokenStatusResponse;
};

export type GetGitlabTokenStatusResponse = GetGitlabTokenStatusResponses[keyof GetGitlabTokenStatusResponses];

export type SetGitlabTokenData = {
    body: SetGitlabTokenBody;
    path?: never;
    query?: never;
    url: '/api/profile/gitlab-token';
};

export type SetGitlabTokenErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetGitlabTokenError = SetGitlabTokenErrors[keyof SetGitlabTokenErrors];

export type SetGitlabTokenResponses = {
    200: GitlabTokenSavedResponse;
};

export type SetGitlabTokenResponse = SetGitlabTokenResponses[keyof SetGitlabTokenResponses];

export type ListTimesheetEntriesData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/timesheet/entries';
};

export type ListTimesheetEntriesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListTimesheetEntriesError = ListTimesheetEntriesErrors[keyof ListTimesheetEntriesErrors];

export type ListTimesheetEntriesResponses = {
    200: TimesheetEntryListResponse;
};

export type ListTimesheetEntriesResponse = ListTimesheetEntriesResponses[keyof ListTimesheetEntriesResponses];

export type CreateTimesheetEntryData = {
    body: CreateTimesheetEntryBody;
    path?: never;
    query?: never;
    url: '/api/timesheet/entries';
};

export type CreateTimesheetEntryErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateTimesheetEntryError = CreateTimesheetEntryErrors[keyof CreateTimesheetEntryErrors];

export type CreateTimesheetEntryResponses = {
    201: TimesheetEntryResponse;
};

export type CreateTimesheetEntryResponse = CreateTimesheetEntryResponses[keyof CreateTimesheetEntryResponses];

export type DeleteTimesheetEntryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/timesheet/entries/{id}';
};

export type DeleteTimesheetEntryErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteTimesheetEntryError = DeleteTimesheetEntryErrors[keyof DeleteTimesheetEntryErrors];

export type DeleteTimesheetEntryResponses = {
    200: SuccessResponse;
};

export type DeleteTimesheetEntryResponse = DeleteTimesheetEntryResponses[keyof DeleteTimesheetEntryResponses];

export type UpdateTimesheetEntryData = {
    body: UpdateTimesheetEntryBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/timesheet/entries/{id}';
};

export type UpdateTimesheetEntryErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateTimesheetEntryError = UpdateTimesheetEntryErrors[keyof UpdateTimesheetEntryErrors];

export type UpdateTimesheetEntryResponses = {
    200: TimesheetEntryResponse;
};

export type UpdateTimesheetEntryResponse = UpdateTimesheetEntryResponses[keyof UpdateTimesheetEntryResponses];

export type GetTimesheetSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/timesheet/settings';
};

export type GetTimesheetSettingsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetTimesheetSettingsError = GetTimesheetSettingsErrors[keyof GetTimesheetSettingsErrors];

export type GetTimesheetSettingsResponses = {
    200: TimesheetSettingsResponse;
};

export type GetTimesheetSettingsResponse = GetTimesheetSettingsResponses[keyof GetTimesheetSettingsResponses];

export type SetTimesheetSettingsData = {
    body: TimesheetSettingsBody;
    path?: never;
    query?: never;
    url: '/api/timesheet/settings';
};

export type SetTimesheetSettingsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetTimesheetSettingsError = SetTimesheetSettingsErrors[keyof SetTimesheetSettingsErrors];

export type SetTimesheetSettingsResponses = {
    200: TimesheetSettingsResponse;
};

export type SetTimesheetSettingsResponse = SetTimesheetSettingsResponses[keyof SetTimesheetSettingsResponses];

export type ListTimesheetCatalogClientsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/timesheet/catalog/clients';
};

export type ListTimesheetCatalogClientsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListTimesheetCatalogClientsError = ListTimesheetCatalogClientsErrors[keyof ListTimesheetCatalogClientsErrors];

export type ListTimesheetCatalogClientsResponses = {
    200: TimesheetCatalogClientListResponse;
};

export type ListTimesheetCatalogClientsResponse = ListTimesheetCatalogClientsResponses[keyof ListTimesheetCatalogClientsResponses];

export type ListTimesheetCatalogApplicationsData = {
    body?: never;
    path?: never;
    query?: {
        clientId?: string;
        applicationId?: string;
    };
    url: '/api/timesheet/catalog/applications';
};

export type ListTimesheetCatalogApplicationsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListTimesheetCatalogApplicationsError = ListTimesheetCatalogApplicationsErrors[keyof ListTimesheetCatalogApplicationsErrors];

export type ListTimesheetCatalogApplicationsResponses = {
    200: TimesheetCatalogApplicationListResponse;
};

export type ListTimesheetCatalogApplicationsResponse = ListTimesheetCatalogApplicationsResponses[keyof ListTimesheetCatalogApplicationsResponses];

export type ListTimesheetCatalogProjectsData = {
    body?: never;
    path?: never;
    query?: {
        clientId?: string;
        applicationId?: string;
    };
    url: '/api/timesheet/catalog/projects';
};

export type ListTimesheetCatalogProjectsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListTimesheetCatalogProjectsError = ListTimesheetCatalogProjectsErrors[keyof ListTimesheetCatalogProjectsErrors];

export type ListTimesheetCatalogProjectsResponses = {
    200: TimesheetCatalogProjectListResponse;
};

export type ListTimesheetCatalogProjectsResponse = ListTimesheetCatalogProjectsResponses[keyof ListTimesheetCatalogProjectsResponses];

export type LookupTimesheetIssueData = {
    body?: never;
    path?: never;
    query: {
        identifier: string;
    };
    url: '/api/timesheet/issue-lookup';
};

export type LookupTimesheetIssueErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type LookupTimesheetIssueError = LookupTimesheetIssueErrors[keyof LookupTimesheetIssueErrors];

export type LookupTimesheetIssueResponses = {
    200: TimesheetIssueLookupResponse;
};

export type LookupTimesheetIssueResponse = LookupTimesheetIssueResponses[keyof LookupTimesheetIssueResponses];

export type GetAdminTimesheetOverviewData = {
    body?: never;
    path?: never;
    query: {
        from: string;
        to: string;
    };
    url: '/api/admin/timesheet';
};

export type GetAdminTimesheetOverviewErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetAdminTimesheetOverviewError = GetAdminTimesheetOverviewErrors[keyof GetAdminTimesheetOverviewErrors];

export type GetAdminTimesheetOverviewResponses = {
    200: AdminTimesheetResponse;
};

export type GetAdminTimesheetOverviewResponse = GetAdminTimesheetOverviewResponses[keyof GetAdminTimesheetOverviewResponses];

export type ListTrackerProjectsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Client ciblé — obligatoire pour un rôle interne, ignoré pour le rôle client.
         */
        clientId?: string;
    };
    url: '/api/tracker/projects';
};

export type ListTrackerProjectsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListTrackerProjectsError = ListTrackerProjectsErrors[keyof ListTrackerProjectsErrors];

export type ListTrackerProjectsResponses = {
    200: TrackerProjectsResponse;
};

export type ListTrackerProjectsResponse = ListTrackerProjectsResponses[keyof ListTrackerProjectsResponses];

export type ListProjectDocumentsData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: {
        /**
         * Client ciblé — obligatoire pour un rôle interne, ignoré pour le rôle client.
         */
        clientId?: string;
    };
    url: '/api/tracker/projects/{projectId}/documents';
};

export type ListProjectDocumentsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListProjectDocumentsError = ListProjectDocumentsErrors[keyof ListProjectDocumentsErrors];

export type ListProjectDocumentsResponses = {
    200: ProjectDocumentListResponse;
};

export type ListProjectDocumentsResponse = ListProjectDocumentsResponses[keyof ListProjectDocumentsResponses];

export type UploadProjectDocumentData = {
    body: {
        file: Blob | File;
        clientId?: string;
        visibleToClient?: 'true' | 'false';
        category?: string;
    };
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/tracker/projects/{projectId}/documents';
};

export type UploadProjectDocumentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UploadProjectDocumentError = UploadProjectDocumentErrors[keyof UploadProjectDocumentErrors];

export type UploadProjectDocumentResponses = {
    201: ProjectDocumentResponse;
};

export type UploadProjectDocumentResponse = UploadProjectDocumentResponses[keyof UploadProjectDocumentResponses];

export type DeleteProjectDocumentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/documents/{id}';
};

export type DeleteProjectDocumentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteProjectDocumentError = DeleteProjectDocumentErrors[keyof DeleteProjectDocumentErrors];

export type DeleteProjectDocumentResponses = {
    200: SuccessResponse;
};

export type DeleteProjectDocumentResponse = DeleteProjectDocumentResponses[keyof DeleteProjectDocumentResponses];

export type DownloadProjectDocumentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/documents/{id}/download';
};

export type DownloadProjectDocumentErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DownloadProjectDocumentError = DownloadProjectDocumentErrors[keyof DownloadProjectDocumentErrors];

export type DownloadProjectDocumentResponses = {
    /**
     * Flux binaire du document projet (toujours en téléchargement, jamais en inline).
     */
    200: Blob | File;
};

export type DownloadProjectDocumentResponse = DownloadProjectDocumentResponses[keyof DownloadProjectDocumentResponses];

export type SearchMeetingParticipantsData = {
    body?: never;
    path?: never;
    query?: {
        q?: string;
        /**
         * Client ciblé — obligatoire ici (route interne), jamais déduit de la réunion.
         */
        clientId?: string;
    };
    url: '/api/tracker/meeting-participants';
};

export type SearchMeetingParticipantsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SearchMeetingParticipantsError = SearchMeetingParticipantsErrors[keyof SearchMeetingParticipantsErrors];

export type SearchMeetingParticipantsResponses = {
    200: ParticipantSuggestionListResponse;
};

export type SearchMeetingParticipantsResponse = SearchMeetingParticipantsResponses[keyof SearchMeetingParticipantsResponses];

export type SummarizeMeetingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/summarize';
};

export type SummarizeMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SummarizeMeetingError = SummarizeMeetingErrors[keyof SummarizeMeetingErrors];

export type SummarizeMeetingResponses = {
    202: MeetingDetailResponse;
};

export type SummarizeMeetingResponse = SummarizeMeetingResponses[keyof SummarizeMeetingResponses];

export type ReviewMeetingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/review';
};

export type ReviewMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ReviewMeetingError = ReviewMeetingErrors[keyof ReviewMeetingErrors];

export type ReviewMeetingResponses = {
    200: MeetingDetailResponse;
};

export type ReviewMeetingResponse = ReviewMeetingResponses[keyof ReviewMeetingResponses];

export type PublishMeetingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/publish';
};

export type PublishMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type PublishMeetingError = PublishMeetingErrors[keyof PublishMeetingErrors];

export type PublishMeetingResponses = {
    200: MeetingDetailResponse;
};

export type PublishMeetingResponse = PublishMeetingResponses[keyof PublishMeetingResponses];

export type UnpublishMeetingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/unpublish';
};

export type UnpublishMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UnpublishMeetingError = UnpublishMeetingErrors[keyof UnpublishMeetingErrors];

export type UnpublishMeetingResponses = {
    200: MeetingDetailResponse;
};

export type UnpublishMeetingResponse = UnpublishMeetingResponses[keyof UnpublishMeetingResponses];

export type CreateMeetingDecisionData = {
    body: CreateMeetingDecisionBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/decisions';
};

export type CreateMeetingDecisionErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateMeetingDecisionError = CreateMeetingDecisionErrors[keyof CreateMeetingDecisionErrors];

export type CreateMeetingDecisionResponses = {
    200: MeetingDetailResponse;
};

export type CreateMeetingDecisionResponse = CreateMeetingDecisionResponses[keyof CreateMeetingDecisionResponses];

export type UpdateMeetingDecisionData = {
    body: UpdateMeetingDecisionBody;
    path: {
        id: string;
        did: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/decisions/{did}';
};

export type UpdateMeetingDecisionErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateMeetingDecisionError = UpdateMeetingDecisionErrors[keyof UpdateMeetingDecisionErrors];

export type UpdateMeetingDecisionResponses = {
    200: MeetingDetailResponse;
};

export type UpdateMeetingDecisionResponse = UpdateMeetingDecisionResponses[keyof UpdateMeetingDecisionResponses];

export type SetMeetingAttendeesData = {
    body: SetMeetingAttendeesBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/attendees';
};

export type SetMeetingAttendeesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type SetMeetingAttendeesError = SetMeetingAttendeesErrors[keyof SetMeetingAttendeesErrors];

export type SetMeetingAttendeesResponses = {
    200: MeetingDetailResponse;
};

export type SetMeetingAttendeesResponse = SetMeetingAttendeesResponses[keyof SetMeetingAttendeesResponses];

export type ListActionItemCandidatesData = {
    body?: never;
    path: {
        id: string;
        aid: string;
    };
    query?: {
        q?: string;
    };
    url: '/api/tracker/meetings/{id}/action-items/{aid}/candidates';
};

export type ListActionItemCandidatesErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListActionItemCandidatesError = ListActionItemCandidatesErrors[keyof ListActionItemCandidatesErrors];

export type ListActionItemCandidatesResponses = {
    200: IssueCandidateListResponse;
};

export type ListActionItemCandidatesResponse = ListActionItemCandidatesResponses[keyof ListActionItemCandidatesResponses];

export type LinkActionItemData = {
    body: LinkMeetingActionItemBody;
    path: {
        id: string;
        aid: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/action-items/{aid}/link';
};

export type LinkActionItemErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type LinkActionItemError = LinkActionItemErrors[keyof LinkActionItemErrors];

export type LinkActionItemResponses = {
    200: MeetingDetailResponse;
};

export type LinkActionItemResponse = LinkActionItemResponses[keyof LinkActionItemResponses];

export type CreateIssueFromActionItemData = {
    body: CreateIssueFromMeetingActionBody;
    path: {
        id: string;
        aid: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/action-items/{aid}/create-issue';
};

export type CreateIssueFromActionItemErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateIssueFromActionItemError = CreateIssueFromActionItemErrors[keyof CreateIssueFromActionItemErrors];

export type CreateIssueFromActionItemResponses = {
    200: MeetingDetailResponse;
};

export type CreateIssueFromActionItemResponse = CreateIssueFromActionItemResponses[keyof CreateIssueFromActionItemResponses];

export type UpdateActionItemData = {
    body: UpdateMeetingActionItemBody;
    path: {
        id: string;
        aid: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}/action-items/{aid}';
};

export type UpdateActionItemErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateActionItemError = UpdateActionItemErrors[keyof UpdateActionItemErrors];

export type UpdateActionItemResponses = {
    200: MeetingDetailResponse;
};

export type UpdateActionItemResponse = UpdateActionItemResponses[keyof UpdateActionItemResponses];

export type ListMeetingsData = {
    body?: never;
    path?: never;
    query?: {
        projectId?: string;
        applicationId?: string;
        /**
         * Client ciblé — obligatoire pour un rôle interne, ignoré pour le rôle client.
         */
        clientId?: string;
    };
    url: '/api/tracker/meetings';
};

export type ListMeetingsErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type ListMeetingsError = ListMeetingsErrors[keyof ListMeetingsErrors];

export type ListMeetingsResponses = {
    200: MeetingListResponse;
};

export type ListMeetingsResponse = ListMeetingsResponses[keyof ListMeetingsResponses];

export type CreateMeetingData = {
    body: CreateMeetingBody;
    path?: never;
    query?: never;
    url: '/api/tracker/meetings';
};

export type CreateMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type CreateMeetingError = CreateMeetingErrors[keyof CreateMeetingErrors];

export type CreateMeetingResponses = {
    201: MeetingDetailResponse;
};

export type CreateMeetingResponse = CreateMeetingResponses[keyof CreateMeetingResponses];

export type DeleteMeetingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}';
};

export type DeleteMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type DeleteMeetingError = DeleteMeetingErrors[keyof DeleteMeetingErrors];

export type DeleteMeetingResponses = {
    200: SuccessResponse;
};

export type DeleteMeetingResponse = DeleteMeetingResponses[keyof DeleteMeetingResponses];

export type GetMeetingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}';
};

export type GetMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type GetMeetingError = GetMeetingErrors[keyof GetMeetingErrors];

export type GetMeetingResponses = {
    200: MeetingDetailResponse;
};

export type GetMeetingResponse = GetMeetingResponses[keyof GetMeetingResponses];

export type UpdateMeetingData = {
    body: UpdateMeetingBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/tracker/meetings/{id}';
};

export type UpdateMeetingErrors = {
    /**
     * Error
     */
    default: ApiErrorBody;
};

export type UpdateMeetingError = UpdateMeetingErrors[keyof UpdateMeetingErrors];

export type UpdateMeetingResponses = {
    200: MeetingDetailResponse;
};

export type UpdateMeetingResponse = UpdateMeetingResponses[keyof UpdateMeetingResponses];
